import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { UIContext, VIEW_CONSTS } from "../../contexts/UIContext";
import { DataContext } from "../../contexts/DataContext";
import { APIContext } from "../../contexts/APIContext";
import { Button } from "../../Theme/Hyper";
import { ControlContext } from "../../contexts/ControlContext";
import { useHistory, useLocation } from "react-router-dom";
import useLocalStorage from "../../Hooks/useLocalStorage";

const TeamNamePanel = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  align-items: center;
  justify-content: center;
  height: 13vh;
  margin-bottom: 1em;
`;
const Team = styled.div`
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  display: flex;
  width: 40%;
  align-items: center;
  height: 54px;
`;
const Middle = styled.div`
  display: flex;
  width: 20%;
  justify-content: space-evenly;
  align-items: center;
  margin-top: -10px;
`;
const TeamName = styled.div`
  padding-left: ${(props) => (props.home ? "0.5em" : "")};
  margin-left: ${(props) => (props.home ? "auto" : "")};
  display: flex;
  font-size: 1.5em;

  width: 100%;
`;
const Score = styled.div`
  display: flex;
  font-size: 3em;
  padding-left: 0.5em;
  padding-right: 0.5em;
  align-items: center;
  justify-content: center;

  border-radius: 2px;
`;
const Row = styled.div`
  display: flex;
  width: 100%;

  align-items: center;
  box-sizing: border-box;
  justify-content: center;
`;

const NavButton = styled(Button)`
  margin: 0.3em;
  margin-top: 0.5em;
  margin-right: 1em;
  margin-left: 1em;
  justify-content: center;
  align-items: center;
  width: 10%;
  background-color: ${(props) => (props.green ? "#0adb93" : props.red ? "#db0a41" : "#181d25")};
  color: ${(props) => (props.selected ? "#1d1d1d" : "")};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
`;

export default function TeamNames({
  setGoalScored,
  game,
  setSelectedPlayer,
  isFruit = false,
}) {
  const history = useHistory();
  const location = useLocation();
  const { setView, selectedTeam, setGoal } = useContext(UIContext);
  const { updateGame, updateCompetition } = useContext(APIContext);
  const { clear } = useContext(ControlContext);
  const { gamesByDate, setSelectedGameID, setSelectedGame, nextGame, setNextGame, lastGame, setLastGame } = useContext(DataContext);
  const [ GameSave ] = useLocalStorage("hyper-combat-fightcard");

 
if (gamesByDate && gamesByDate.length > 0) {
        let gamepos = gamesByDate?.map(function(games) {return games._id }).indexOf(game._id);
        let nextGameupdate = gamesByDate[(parseInt(gamepos)+1)] || "";
        let lastGameupdate = gamesByDate[(gamepos-1)] || "";
        setNextGame(nextGameupdate);
        setLastGame(lastGameupdate);
      } else {
        let cachedresult = GameSave.cachedGames
        let gamepos = cachedresult?.map(function(games) {return games._id }).indexOf(game._id);
        let nextGameupdate = cachedresult[(parseInt(gamepos)+1)] || "";
        let lastGameupdate = cachedresult[(gamepos-1)] || "";
        setNextGame(nextGameupdate);
        setLastGame(lastGameupdate);
}


  let homeBGColour = game.home_fighter?.shorts_colour || "";
  let awayBGColour = game.away_fighter?.shorts_colour || "";

  let try_points = game?.competition?.competition_type === "union" ? 5 : 4;
  let conversion_points =
    game?.competition?.competition_type === "union" ? 2 : 2;
  let penalty_kick_points =
    game?.competition?.competition_type === "union" ? 3 : 2;
  let penalty_try_points =
    game?.competition?.competition_type === "union" ? 7 : 4;
  let drop_goal_points =
    game?.competition?.competition_type === "union" ? 3 : 1;

  return (
    <TeamNamePanel>
      <Row>
        {game?.title}
        {game?.gold_fight === 1 ? "- Gold Fight" : ""}
      </Row>
      <Row>
        { lastGame !== "" &&
        <NavButton red onClick={() => {setSelectedGameID(lastGame._id);
          updateCompetition({id: game?.competition?._id, active_fight: lastGame._id})
           setSelectedGame(lastGame);
                      let path = location.pathname.split('/')[0];


                      history.push({
                        pathname:
                          path.replace("/", "") +
                          "/" +
                          lastGame._id,
                      });
                    }}>
          ← {lastGame?.home_fighter?.last_name} vs {lastGame?.away_fighter?.last_name}
        </NavButton>
        }
        <Team
          style={{
            borderBottom:
              "3px solid " + (homeBGColour ? homeBGColour : "rgba(0,0,0,0)"),
            opacity:
              !selectedTeam || selectedTeam._id === game.home_fighter._id
                ? "1"
                : ".2",
          }}
        >
          <TeamName home style={{ display: "flex", justifyContent: "end" }}>
            {game?.home_fighter?.first_name} {game?.home_fighter?.last_name} -{" "}
            {game?.home_fighter?.nationality?.code}
          </TeamName>
        </Team>
        <Middle>
          {/* {!isFruit && (
          <Button
            onClick={() => {
              clear();
            }}
          >
            CLEAR ALL GFX <br />
            (Ctl+Shift+Q)
          </Button>
        )} */}
        </Middle>
        <Team
          style={{
            borderBottom:
              "3px solid " + (awayBGColour ? awayBGColour : "rgba(0,0,0,0)"),
            opacity:
              !selectedTeam || selectedTeam._id === game.away_fighter._id
                ? "1"
                : ".2",
          }}
        >
          <TeamName>
            {game.away_fighter?.first_name} {game.away_fighter?.last_name} -{" "}
            {game?.away_fighter?.nationality?.code}
          </TeamName>
        </Team>
        { nextGame !== "" &&
        <NavButton green onClick={() => {setSelectedGameID(nextGame._id);
          updateCompetition({id: game?.competition?._id, active_fight: nextGame._id})
           setSelectedGame(nextGame);
                      let path = location.pathname.split('/')[0];


                      history.push({
                        pathname:
                          path.replace("/", "") +
                          "/" +
                          nextGame._id,
                      });
                    }}>
           {nextGame?.home_fighter?.last_name} vs {nextGame?.away_fighter?.last_name} →
        </NavButton>
        }
      </Row>
    </TeamNamePanel>
  );
}
